import { apiClient } from "../clientApi";
import { useMutation } from "@tanstack/react-query";
import type { DefaultError } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

export const useSendManualSurvey = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: (data: any, variables: any, context: any) => void;
  onFail?: (error: any, variables: any, context: any) => void;
}) =>
  useMutation<any, DefaultError, any>({
    mutationFn: async (form) => {
      const { data } = await apiClient.post<any, AxiosResponse<any>, any>(`/email/manual-survey`, form);

      return data as any;
    },
    onSuccess,
    onError: onFail,
  });
